<script setup lang="ts">
import { FormLayout, FormLayoutRow, FormLayoutLabel } from '@/components/Form';
import { MultiEditorField } from '@/components/MultiEditor/MultiEditorField';

const fields = defineModel<Map<string, MultiEditorField<any>>>();

const props = withDefaults(defineProps<{ info?: string }>(), { info: '' });
</script>

<template>
    <div>
        <div
            v-if="props.info"
            class="mb-2"
        >
            <span v-html="$tm(props.info, '', true)"></span>
        </div>
        <FormLayout>
            <FormLayoutRow
                v-for="[key, field] in fields"
                :key="key"
            >
                <FormLayoutLabel :for="key">
                    {{ $tm(field.TranslationKey) }}
                </FormLayoutLabel>
                <component
                    :is="field.Editor"
                    v-model="field.Value"
                    v-bind="field.Params"
                    :id="key"
                />
            </FormLayoutRow>
        </FormLayout>
    </div>
</template>
